import { Button } from "antd";
import { ColumnsType } from "antd/es/table";
import TableWithCollapse from "../../component/TableWithCollapse";
import { SuspendApptList } from "./SuspendPage";
import * as ewcms from "../EWCMS/styleMaster";

const defaultBtnStyle = ewcms.defaultBtnStyle;

type SuspendTableProps = {
  appointmentList: SuspendApptList[];
  onStatusControlClick: (
    apptPk: number,
    action: "suspend" | "activate"
  ) => void;
  setLimit: (value: number) => void;
  setOffset: (value: number) => void;
  totalCount: number;
};

const SuspendAppointmentTable = (props: SuspendTableProps) => {
  const {
    appointmentList,
    onStatusControlClick,
    setLimit,
    setOffset,
    totalCount,
  } = props;

  const suspendTableColumn: ColumnsType<SuspendApptList> = [
    {
      title: "Staff No",
      dataIndex: "staffNo",
      key: "staffNo",
    },
    {
      title: "Appointment Period",
      dataIndex: "apptPeriod",
      key: "apptPeriod",
    },
    {
      title: "Post Title",
      dataIndex: "postTitle",
      key: "postTitle",
    },
    {
      title: "Job ID",
      dataIndex: "jobId",
      key: "jobId",
    },
    {
      title: "Status",
      dataIndex: "isSuspend",
      key: "isSuspend",
      render: (isSuspend) => {
        return isSuspend ? (
          <div style={{ color: "red" }}>Suspended</div>
        ) : (
          <div style={{ color: "green" }}>Activating</div>
        );
      },
    },
    {
      dataIndex: "statusControl",
      key: "statusControl",
      render: (statusControl) => {
        return statusControl.isSuspend ? (
          <Button
            className={defaultBtnStyle + " cust-button-height"}
            onClick={() => {
              onStatusControlClick(statusControl.apptPk, "activate");
            }}
          >
            Activate
          </Button>
        ) : (
          <Button
            className={defaultBtnStyle + " cust-button-height"}
            onClick={() => {
              onStatusControlClick(statusControl.apptPk, "suspend");
            }}
          >
            Suspend
          </Button>
        );
      },
    },
  ];

  const handleChange = (pagination, filters, sorter) => {
    const newLimit = pagination.pageSize;
    const newOffset =
      pagination.current * pagination.pageSize - pagination.pageSize;

    setLimit(newLimit);
    setOffset(newOffset);

    // console.log('*****pagination:', pagination);
    // const params: any = {};
    // if (sorter.hasOwnProperty("column")) {
    //   params.order = { field: sorter.field, dir: sorter.order };
    // }
  };

  return (
    <TableWithCollapse
      handleChange={handleChange}
      data={appointmentList}
      columns={suspendTableColumn}
      onRowClick={() => {}}
      hideCol={[]}
      pagination={{ total: totalCount }}
    />
  );
};

export default SuspendAppointmentTable;
